import { render } from "./ServicePassiveCheck.vue?vue&type=template&id=8cc516aa"
import script from "./ServicePassiveCheck.vue?vue&type=script&lang=js"
export * from "./ServicePassiveCheck.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__